const navLinks = [
  { href: "#chapters", label: "最新更新" },
  { href: "#synopsis", label: "故事简介" },
  { href: "#characters", label: "主要人物" },
  { href: "#catalog", label: "全集目录" },
  { href: "#guide", label: "追更指南" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/80">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-heart-2-fill text-lg" />
              </span>
              <span className="font-heading text-xl text-foreground-950">
                泡在我家的辣妹网
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              专注《泡在我家的辣妹》最新话更新进度、漫画全集目录与追更指南的资讯站，追更泡在我家的辣妹不用到处找，最新内容点开即可直达。
            </p>
          </div>

          <nav aria-label="页脚导航" className="md:justify-self-center">
            <h3 className="text-sm font-bold text-foreground-950">栏目导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:justify-self-end">
            <h3 className="text-sm font-bold text-foreground-950">联系与反馈</h3>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li>
                <a
                  href="mailto:paozai@example.com"
                  className="inline-flex items-center gap-2 transition-colors hover:text-primary-700"
                >
                  <i className="ri-mail-line text-base" />
                  paozai@example.com
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="inline-flex items-center gap-2 transition-colors hover:text-primary-700"
                >
                  <i className="ri-question-line text-base" />
                  阅读常见问题
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 泡在我家的辣妹网 · 仅供漫画资讯与追更参考
          </p>
          <p className="text-xs text-foreground-500">
            最新话更新进度与全集目录持续维护中
          </p>
        </div>
      </div>
    </footer>
  );
}